<template>
    <div class="settings">
        <div class="content">
            <template v-if="role == 'admin'">
                <h1>Definições</h1>
                <label>
                    <div class="label">Nome</div>
                    <input type="text" v-model="newName" @keydown="setName">
                </label>

                <label>
                    <input type="file" @change="newLogoUpload">
                    <div class="label">Logotipo</div>
                </label>

                <hr>
            </template>
            <h1>Perfil</h1>
            <label for="image-upload">
                <input type="file" id="image-upload" name="profileImage" ref="imageInput" @change="handleImageUpload">
                <div class="label">Imagem de Perfil</div>
            </label>
            <div>
                <p>Imagem Escolhida</p>
                <div>
                    <img v-if="!hideImage" :src="imageAPI">
                </div>
                <p v-text="chooseImage"></p>
                <div class="buttons">
                    <button class="button" v-if="isImageUploaded" @click="uploadImage">Submeter</button>
                    <button class="button" @click="cancel">Retroceder</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"PopupSettings",
    props: {
    },
    data() {
        return {
            image: null,
            chooseImage: null,
            imageUploaded: null,
            selectedImage: 'Escolher a Imagem',
            hideImage: false,
            imageAPI: null,
            logoToUpload: null,
            setNameTimeout: null,
            newName: "",
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        setName() {
            clearTimeout(this.setNameTimeout)
            this.setNameTimeout = setTimeout(() => {
                this.$store.dispatch('instance/setName', this.newName)
            }, 400)
        },
        newLogoUpload(e) {
            this.logoToUpload = e.target.files[0]
            this.$store.dispatch('instance/uploadLogo', this.logoToUpload)
        },
        handleImageUpload(event) {
            this.image = event.target.files[0]
            if (this.image) {
                this.selectedImage = this.image.name;
            }
        },

        async uploadImage() {
            if (!this.image) {
                this.chooseImage = "Please select Image"
            }

            this.$store.dispatch('profiles/update', { image: this.image, name: this.currentUser.displayName })
        },
    },

    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        role() {
            return this.$store.state.users.role
        },
        name() {
            return this.$store.state.instance.name
        },
        isImageUploaded() {
            return this.image;
        },
        previewSrc() {
            return URL.createObjectURL(this.logoToUpload)
        },
    },

    watch: {
        name: {
            immediate: true,
            handler() {
                if (this.name == null) {
                    return
                }
                if (this.newName == this.name) {
                    return
                }
                this.newName = this.name
            },
        },
    },

    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.settings {

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--black), .7);
    
    .content {
        z-index: 8000;
        background-color: var(--sidebar-bg-color);
        border-radius: 10px;
        padding: 2rem;
    }
    

    label {
        input[type=file] {
            display: none;

            &+.label {
                padding: 1rem;
                border: 2px dashed;
                border-radius: 10px;
                width: fit-content;
            }
        }

        img {
            max-width: 50px;
            max-height: 50px;
        }
    }

    .buttons {
            display: flex;
            justify-content: space-between;
            gap: 1rem;
            width: 100%;

            .button {
                flex: 1;
                padding: 1rem;
                font-size: 18px;
                cursor: pointer;
                text-align: center;
                border: none;
                border-radius: 5px;
                background-color: var(--text-color);
                color: var(--white);
                transition: background-color 0.3s ease;

                &:hover {
                    background-color: var(--highlight-color, 10%);
                }

                &[type="button"] {
                    background-color: var(--text-second-color);

                    &:hover {
                        background-color: var(--text-darken-color);
                    }
                }
            }
        }
}
</style>
